import { Collapse as MuiCollapse, CollapseProps as MuiCollapseProps } from '@mui/material';

export type CollapseProps = MuiCollapseProps;

export const Collapse = MuiCollapse;
